import {cn} from '../../../lib/utils';
import {IconProps} from '../../../app/data/types/Icon';


export default function SubtitleArrowIcon({className}: IconProps) {
	return (
		<svg className={cn('w-10 h-10', className)} >
			<path className='fill-blue'
				  d="M20 25.375q.25 0 .479-.083.229-.084.438-.292l4.166-4.167q.292-.291.292-.708t-.292-.708q-.333-.334-.75-.334-.416 0-.708.334l-2.542 2.541v-6.833q0-.458-.312-.75-.313-.292-.771-.292t-.771.292q-.312.292-.312.75v6.833l-2.542-2.541q-.292-.334-.708-.334-.417 0-.75.334-.292.291-.292.708t.292.708L19.083 25q.209.208.438.292.229.083.479.083Zm0 10.458q-3.333 0-6.208-1.229t-5.021-3.375q-2.146-2.146-3.375-5.021T4.167 20q0-3.292 1.229-6.187 1.229-2.896 3.375-5.042t5.021-3.375Q16.667 4.167 20 4.167q3.292 0 6.188 1.229 2.895 1.229 5.041 3.375 2.146 2.146 3.375 5.042 1.229 2.895 1.229 6.187 0 3.333-1.229 6.208t-3.375 5.021q-2.146 2.146-5.041 3.375-2.896 1.229-6.188 1.229Z"></path>
		</svg>
	);
}
